import { PayMethods, Sexes } from "../../models/enums/enums";
import { Sport } from "../../models/sports";

export const sexTypes: Sexes[] = Object.values(Sexes);

export const emptySport: Sport = {
  name: "",
  paymentType: "",
  description: "",
  price: 0,
  expirated: "",
  visible: true,
};

export const payMethods: PayMethods[] = Object.values(PayMethods);

export const monthsValues = [
  { name: "Enero", value: 0 },
  { name: "Febrero", value: 1 },
  { name: "Marzo", value: 2 },
  { name: "Abril", value: 3 },
  { name: "Mayo", value: 4 },
  { name: "Junio", value: 5 },
  { name: "Julio", value: 6 },
  { name: "Agosto", value: 7 },
  { name: "Septiembre", value: 8 },
  { name: "Octubre", value: 9 },
  { name: "Noviembre", value: 10 },
  { name: "Diciembre", value: 11 },
];

export const yearsValues = [2024, 2025, 2026, 2027, 2028, 2029, 2030];
export const statuses = [
  { value: "All", label: "Todos los estados" },
  { value: "Defeated", label: "Vencidas" },
  { value: "For_defeated", label: "Por vencer" },
  { value: "Paid", label: "Pagadas" },
  // { value: "Unpaid", label: "Sin deudas" },
];

export const paymentTypes = [
  { value: "daily", label: "Diario" },
  { value: "weekly", label: "Semanal" },
  { value: "fortnightly", label: "Quincenal" },
  { value: "monthly", label: "Mensual" },
];
